export const tokens = {
  colors: {
    bg: '#f4f6fb',
    bg2: '#ffffff',
    panel: '#ffffff',
    panel2: '#eef1f8',

    line: 'rgba(20,24,45,.09)',
    line2: 'rgba(20,24,45,.15)',

    txt: '#171a26',
    muted: '#666c7e',
    muted2: '#98a0b2',

    indigo: '#6c72ff',
    cyan: '#0e9b97',
    gold: '#b07d1a',

    ok: '#1f9d63',
    warn: '#b07d1a',
    red: '#e5484d',
  },

  gradient: {
    main: 'linear-gradient(120deg,#6c72ff 0%,#39d3d0 100%)',
    soft: 'linear-gradient(120deg,rgba(108,114,255,.12),rgba(57,211,208,.10))',
    avatar: 'conic-gradient(from 210deg,#6c72ff,#39d3d0,#e5b567,#6c72ff)',
  },

  radius: {
    lg: 18,   // tarjetas principales (.hero, .card)
    md: 12,   // botones, chips grandes, inputs
    sm: 9,    // botones pequeños de icono
  },

  shadow: {
    card: '0 1px 2px rgba(20,24,45,.04), 0 12px 30px rgba(20,24,45,.05)',
    gradientButton: '0 8px 20px rgba(108,114,255,.28)',
    fab: '0 14px 34px rgba(108,114,255,.34)',
  },

  font: {
    family:
      '-apple-system,BlinkMacSystemFont,"Segoe UI",Inter,Roboto,Helvetica,Arial,sans-serif',
    baseSize: 14.5,
  },

  avatarPalette: [
    'linear-gradient(135deg,#6c72ff,#39d3d0)',
    'linear-gradient(135deg,#e5b567,#ff8f6b)',
    'linear-gradient(135deg,#8b5cf6,#ec4899)',
    'linear-gradient(135deg,#39d3d0,#4ad991)',
    'linear-gradient(135deg,#5c7cff,#8b5cf6)',
    'linear-gradient(135deg,#ff6b6b,#e5b567)',
  ],
};

export function gradientForName(name = '') {
  let hash = 0;
  for (const char of name) {
    hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  }
  return tokens.avatarPalette[hash % tokens.avatarPalette.length];
}

export default tokens;